import { createdFirst } from 'src/Router/routes'
import { CampaignStatusEnum } from 'src/Types/campaigns'

export const preReleaseCreatedPath = `${createdFirst}/spotify-pre-release`

interface PreReleaseCreatedUrlParams {
  campaignId: number
  status: CampaignStatusEnum
  search?: URLSearchParams
  token?: string
}

export const buildPreReleaseCreatedUrl = ({
  campaignId,
  status,
  search,
  token,
}: PreReleaseCreatedUrlParams): string => {
  const params = new URLSearchParams(search?.toString())
  params.set('status', status)

  if (token) {
    params.set('sc_token', token)
  }

  return `${preReleaseCreatedPath}/${campaignId}?${params.toString()}`
}
